import React, { useState } from "react";
import "./Faqs.css";
import { FaChevronDown } from "react-icons/fa";

const faqs = [
  {
    question: "What is the cancellation policy?",
    answer: "You can cancel up to 24 hours before the trip for a full refund. After that, cancellation charges may apply."
  },
  {
    question: "Are there any hidden charges?",
    answer: "No, all prices are transparent and inclusive of applicable taxes. Any extra services are optional."
  },
  {
    question: "Do you provide tempo travellers with AC?",
    answer: "Yes, we provide both AC and Non-AC tempo travellers depending on your requirements."
  },
  {
    question: "How do I book a vehicle?",
    answer: "Simply select your trip details on our website, choose your preferred vehicle, and confirm the booking online."
  },
  {
    question: "What seating capacities are available?",
    answer: "We offer tempo travellers in multiple seating options like 9-seater, 12-seater, 17-seater, 20-seater, and 26-seater."
  },
  {
    question: "Do you provide drivers with the tempo traveller?",
    answer: "Yes, all our tempo travellers come with experienced, professional drivers for a safe and hassle-free journey."
  },
];


const Faqs = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleFAQ = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <div className="faqs-section">
      <h2 className="faqs-heading">Frequently Asked <span>Questions</span> (FAQ's)</h2>
      <div className="faqs-list">
        {faqs.map((faq, index) => (
          <div 
            key={index} 
            className={`faq-item ${activeIndex === index ? "active" : ""}`} 
            onClick={() => toggleFAQ(index)}
          >
            <div className="faq-question">
              <h4>{faq.question}</h4>
              <FaChevronDown className="faq-icon" />
            </div>
            <div className="faq-answer">
              <p>{faq.answer}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Faqs;
